import { MessageThread } from '@/features/Messages/MessageThread';
import { useStudentTopicThread, useSendTopicMessage } from '@/lib/hooks/useTopicMessages';
import { usePreviewStore } from '@/stores/previewStore';

export function AskTrainerSection({ topicId }: { topicId: string }) {
  const { data, isLoading } = useStudentTopicThread(topicId, true);
  const send = useSendTopicMessage(['topic-messages', 'student', topicId]);
  const previewActive = usePreviewStore((s) => s.active);

  return (
    <div>
      <h3 className="font-heading text-base font-semibold text-foreground">Ask your trainer</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Questions about this topic go to your batch trainer, who&apos;ll be notified and can reply here.
      </p>
      <div className="mt-4 rounded-2xl border border-border p-4">
        <MessageThread
          messages={data?.messages ?? []}
          self={data?.self ?? ''}
          loading={isLoading}
          sending={send.isPending}
          onSend={(body) => send.mutate({ batch_topic_id: topicId, body })}
          emptyText="No questions yet. Ask your trainer anything about this topic."
          disabled={previewActive}
        />
      </div>
    </div>
  );
}
